export const plural = (input: number) => {
  return input === 1 ? "" : "s";
};

export default plural;
